

export default () => {
  return {
    restrict:'A',
    terminal: true,
    link: function(scope, element, attr) {
      element.on('error', function() {
        element.attr('src', attr.onErrorSrc);
      })

      if(!element.src && attr.onErrorSrc){
        element.attr('src', attr.onErrorSrc);
      }
    }
  };
};



// WEBPACK FOOTER //
// src/app/components/onErrorSrc/on-error-src.directive.ts